import * as XLSX from "xlsx";
import dayjs from "dayjs";
import {
  agentCollectionLogColumns,
  agentCollectionSummaryColumns,
} from "./constants";

export function formatReportExportValue(
  value: unknown,
  columnId: string,
): string | number {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "string" && value.toLowerCase() === "null")
  ) {
    return "";
  }
  if (columnId.toLowerCase().includes("date")) {
    return dayjs(String(value)).format("DD/MM/YYYY HH:mm");
  }
  if (typeof value === "number") {
    return value;
  }
  return String(value);
}

function sheetFromColumns(
  columns: { id: string; label: string }[],
  rows: Record<string, unknown>[],
) {
  const header = columns.map((col) => col.label);
  const body = rows.map((row) =>
    columns.map((col) => formatReportExportValue(row[col.id], col.id)),
  );
  return XLSX.utils.aoa_to_sheet([header, ...body]);
}

export function downloadAgentCollectionExcel(
  summary: Record<string, unknown>[],
  logEntries: Record<string, unknown>[],
) {
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    sheetFromColumns(agentCollectionSummaryColumns, summary),
    "Summary",
  );
  XLSX.utils.book_append_sheet(
    workbook,
    sheetFromColumns(agentCollectionLogColumns, logEntries),
    "Entries-Logs",
  );

  const fileName = `Agent_Collection_Report_${dayjs().format("YYYY-MM-DD_HHmm")}.xlsx`;
  XLSX.writeFile(workbook, fileName);
}
